import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-[#faf6f0] text-gray-900 py-20 px-4" data-id="element-193">
      <div className="max-w-4xl mx-auto text-center" data-id="element-194">
        <p className="font-oswald text-sm md:text-base font-bold tracking-[0.2em] text-gray-500 uppercase mb-4" data-id="element-195">
          Presentamos
        </p>

        <h2 className="font-oswald text-5xl md:text-7xl font-bold mb-10 text-[#2a1f14] uppercase tracking-tight drop-shadow-sm" data-id="element-196">
          MEGA PACK <span className="text-[#b5634b]" data-id="element-197">CLARIDAD MENTAL</span>
        </h2>

        <p className="font-opensans text-xl md:text-2xl text-gray-700 mb-10 max-w-3xl mx-auto" data-id="element-198">
          Un sistema basado en enseñanzas contemplativas que te ayudará a:
        </p>

        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border-b-4 border-[#c9a96e] max-w-3xl mx-auto mb-12 text-left" data-id="element-199">
          <ul className="space-y-6" data-id="element-200">
            {['entender cómo funciona tu mente', 'dejar de sobrepensar', 'controlar mejor tus emociones', 'recuperar la calma mental'].map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-201">
                <CheckCircle2Icon className="w-8 h-8 text-[#7a9e7a] flex-shrink-0" data-id="element-202" />
                <span className="font-opensans text-xl md:text-2xl font-semibold text-gray-800" data-id="element-203">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="font-opensans text-2xl md:text-3xl space-y-4" data-id="element-204">
          <p className="text-gray-700" data-id="element-205">
            Todo explicado de forma clara, simple y práctica.
          </p>
          <p className="font-bold text-[#b5634b] uppercase tracking-wide" data-id="element-206">
            Sin técnicas complicadas.
          </p>
          <p className="font-bold bg-[#2a1f14] text-white inline-block px-6 py-3 rounded-lg shadow-md mt-4" data-id="element-207">
            Solo herramientas reales que puedes aplicar desde el primer día.
          </p>
        </div>
      </div>
    </section>;
}